/**
 * Default timing for animations
 */
export const ANIMATION_DEFAULT = '250ms ease-in-out';
